export const NEXT_EVENTS_LOOKAHEAD_DAYS = 14;

const toIsoDateLocal = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getNextEventsRange = (
  now: Date = new Date()
): { readonly fromDate: string; readonly toDate: string } => {
  const from = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const to = new Date(from);
  to.setDate(to.getDate() + (NEXT_EVENTS_LOOKAHEAD_DAYS - 1));
  return {
    fromDate: toIsoDateLocal(from),
    toDate: toIsoDateLocal(to),
  };
};
